const Nosotros = () => {
  return (
    <>
      <section className="bg-white dark:bg-gray-900" id="nosotros">
        <div className="max-w-screen-xl px-4 py-8 mx-auto lg:py-16">
          <div
            className="text-center max-w-4xl mx-auto mb-16"
            data-aos="fade-down"
          >
            <h2 className="text-3xl sm:text-5xl lg:text-6xl font-bold text-white leading-tight">
              Nosotros{" "}
            </h2>
          </div>
          <p data-aos="fade-down" className="mb-8 font-light text-center text-gray-300 sm:text-xl dark:text-gray-400">
          Devparts es una empresa enfocada en el desarrollo, comprometida con resolver las necesidades de nuestros clientes.
          Devparts es brindar soluciones; es crear la pieza única que le dará a tu negocio el impulso hacia el mundo digital.            <br />
          </p>
        </div>
      </section>
    </>
  );
};

export default Nosotros;
